import { Helmet } from 'react-helmet-async';

const SEOHead = ({ 
  title = "Taxi-98 | Nassau Airport Taxi & LPIA Transfer Service | Bahamas",
  description = "Professional Nassau airport taxi service. Book reliable LPIA transfers, Paradise Island rides, and cruise port pickups. Official government rates. Available 24/7 in New Providence, Bahamas.",
  canonical = "",
  ogType = "website",
  ogImage = "/images/taxi98-og-image.jpg",
  keywords = ""
}) => {
  const siteUrl = "https://taxi-98.com";
  const fullUrl = canonical ? `${siteUrl}${canonical}` : siteUrl;

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      
      {/* Canonical URL */}
      <link rel="canonical" href={fullUrl} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={`${siteUrl}${ogImage}`} />
      <meta property="og:site_name" content="Taxi-98" />
      <meta property="og:locale" content="en_US" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={fullUrl} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={`${siteUrl}${ogImage}`} />

      {/* Business/Location Meta */}
      <meta name="geo.region" content="BS-NP" />
      <meta name="geo.placename" content="Nassau" />
      <meta name="geo.position" content="25.0443;-77.3504" />
      <meta name="ICBM" content="25.0443, -77.3504" />
    </Helmet>
  );
};

export default SEOHead;
